import type { FC } from 'react'
import type { Document as RichTextDocument } from '@contentful/rich-text-types'

import Badge from '@segment/matcha/components/Badge'
import { CalendarIcon, MapPinIcon } from '@segment/matcha/components/Icons/Brandbook'
import ButtonText from '@segment/matcha/components/ButtonText'
import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'

import CardBase, * as EventCard from '@segment/matcha/recipes/Card'
import RichText from '@segment/matcha/recipes/RichText'

import type { EventCard as EventCardType } from '@segment/api/routes/events/queries'

export interface CardProps {
  title?: EventCardType[`title`]
  content: EventCardType[`content`]
  ctaText?: EventCardType[`ctaText`]
  url?: EventCardType[`url`]
  dateStr?: EventCardType[`dateStr`]
  eventType?: EventCardType[`eventType`]
  region?: EventCardType[`region`]
}
const Card: FC<CardProps> = ({ title, content, ctaText, url, dateStr, eventType, region }) => {
  return (
    <CardBase href={url}>
      <EventCard.Body>
        <EventCard.Accessories>
          <EventCard.AccessoriesRow>
            <CalendarIcon size="small" />
            <EventCard.Label>{dateStr}</EventCard.Label>
            <EventCard.Label>•</EventCard.Label>
            <MapPinIcon size="nav" />
            <EventCard.Label>{region}</EventCard.Label>
          </EventCard.AccessoriesRow>
          <EventCard.AccessoriesRow>
            <Badge variant="outlined">{eventType}</Badge>
          </EventCard.AccessoriesRow>
        </EventCard.Accessories>
        <EventCard.Copy>
          <EventCard.Headline tag="h2">{title}</EventCard.Headline>
          <EventCard.Description tag="div">
            <RichText data={content as RichTextDocument} />
          </EventCard.Description>
        </EventCard.Copy>
        <EventCard.Action alignment="left">
          <ButtonText iconEnd={ChevronRightIcon}>{ctaText}</ButtonText>
        </EventCard.Action>
      </EventCard.Body>
    </CardBase>
  )
}

export default Card
